module.exports = __webpack_public_path__ + "static/device_tablet_apple_dark_portrait-dfe5ff9aa3f97338f7a5af828e65c233.png";